import { useEffect } from 'react';
import { intercomBoot } from '~/services/intercom';
import { sentryIdentity } from '~/services/sentry';
import { datadogIdentity } from '~/services/datadog';
import useMst from '~/hooks/use_mst';

const useAnalytics = () => {
  const {
    auth: { user }
  } = useMst();
  useEffect(() => {
    if (user?.id) {
      intercomBoot({
        userId: user.id,
        email: user.email,
        name: user.fullName,
        externalId: user.external_id,
        userHash: user.intercom_identity
      });
      sentryIdentity(user);
      datadogIdentity(user);
    }
  }, [user]);
};

export default useAnalytics;
